"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CustomBreadcrumb = _ref => {
  let {
    id,
    containerClassName,
    hasMargin,
    isHiddenMobile,
    children,
    ...rest
  } = _ref;
  const [ready, setReady] = (0, _react.useState)();
  (0, _react.useLayoutEffect)(() => {
    setReady(true);
  }, []);
  if (ready) {
    const breadcrumbRoot = document.getElementById('breadcrumb-container-1');
    const customBreadcrumb = /*#__PURE__*/_react.default.createElement("div", {
      className: "breadcrumb-wrapper",
      "data-testid": rest['data-testid']
    }, children);
    if (typeof breadcrumbRoot !== 'undefined' && breadcrumbRoot) {
      return /*#__PURE__*/_reactDom.default.createPortal(customBreadcrumb, breadcrumbRoot);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id || 'breadcrumb-container-1',
      className: `${containerClassName ? 'containerClassName' : 'breadcrumb-container'} ${isHiddenMobile ? 'is-hidden-mobile' : ''} ${hasMargin ? 'mt-2 mb-2' : ''}`
    }, customBreadcrumb);
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
};
CustomBreadcrumb.propTypes = {
  id: _propTypes.default.string,
  hasMargin: _propTypes.default.bool,
  isHiddenMobile: _propTypes.default.bool,
  containerClassName: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  'data-testid': _propTypes.default.string
};
CustomBreadcrumb.defaultProps = {
  isHiddenMobile: true,
  hasMargin: true
};
var _default = exports.default = CustomBreadcrumb;
//# sourceMappingURL=CustomBreadcrumb.js.map